/**
 * Google Analytics loader — call loadGoogleAnalytics(measurementId) explicitly.
 * Does NOT auto-run on import.
 */

let gaLoaded = false;

/**
 * Dynamically injects the gtag.js script and initialises GA4.
 * Safe to call multiple times — only runs once per page session.
 *
 * @param {string} measurementId  e.g. "G-XXXXXXXXXX"
 */
export function loadGoogleAnalytics(measurementId) {
  if (!measurementId || gaLoaded) return;

  // Inject the gtag.js script tag
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head?.appendChild(script);

  // Initialise the data layer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer?.push(args);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId, {
    // Disable automatic page_view — we fire it manually on each route change
    send_page_view: false,
  });

  gaLoaded = true;
}

/**
 * Send a page_view event for the current location.
 * No-op if GA has not been loaded yet.
 *
 * @param {string} measurementId  e.g. "G-XXXXXXXXXX"
 * @param {string} pagePath       e.g. "/about"
 * @param {string} pageTitle      document.title at the time of navigation
 */
export function trackPageView(measurementId, pagePath, pageTitle) {
  if (!gaLoaded || !window.gtag || !measurementId) return;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle || document.title,
    send_to: measurementId,
  });
}
